<template>
    <v-content>
       <v-container>
          <v-card
            flat
            outlined
            color="transparent"
          >
            <v-card-title>Services</v-card-title>
            <v-divider />
            <v-row>
              <v-col md="7" sm="12">
                <v-card-title class="py-2">Machining</v-card-title>
                <v-card-text>
                      We machine tooling and components out of tool steel, aluminum, plastics, and much
                      more. Our team routinely holds +/- .0005 tolerances to deliver our customers with top
                      quality products in industries like aerospace, energy, mining, agriculture, electronics,
                      construction, and many more.
                </v-card-text>
                <v-card-title class="py-2">Die Design and Build</v-card-title>
                <v-card-text>
                      Our staff can design and machine dies to accomplish your fabrication goals. We can
                      build dies to notch, punch, trim or whatever else you may need to keep you operating
                      efficiently.
                </v-card-text>
              </v-col>
              <v-col md="5" sm="12" class="pt-5">
                <v-img
                    :src="require('../assets/services2.jpg')"
                    width="80%"
                    height="auto"
                    contain
                    class="mt-5"
                    style="margin-left:10%"
                ></v-img>
              </v-col>
            </v-row>

            <v-row>
              <v-col md="7" sm="12" class="pt-0">
                <v-card-title class="py-2">Casting Machining</v-card-title>
                <v-card-text>
                      Extensive knowledge on work holding and machining experience make us capable of
                      the toughest casting machining jobs. We can develop a method to machine your
                      castings and provide you with consistent high quality parts.
                </v-card-text>
                <v-card-title class="py-2">Repair Work</v-card-title>
                <v-card-text>
                      If you are struggling to find a solution to fix a die, machine, or part, contact us to have
                      your problem resolved. We can develop creative solutions to get your assets back up
                      and running.
                </v-card-text>
              </v-col>
              <v-col md="5" sm="12" class="pt-0">
                <v-img
                    :src="require('../assets/services1.jpg')"
                    width="80%"
                    height="auto"
                    contain
                    class="mt-5"
                    style="margin-left:10%"
                ></v-img>
              </v-col>
            </v-row>
          </v-card>
       </v-container>
    </v-content>
</template>

<script>


export default {
  name: 'services',
  components: {

  },
  props: [

  ]
}
</script>

<style scoped>

</style>

<style src="../index.css"></style>